import { RESET_ALL_REDUCERS } from "./types"

export const resetAllReducers = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_ALL_REDUCERS,
    })
  }
}
